import { VacancyDescription, VacancyProps } from "storyblok/components";

const escapedChararacters = [
    { escaped: "&amp;", regular: "&" },
    { escaped: "&#39;", regular: "'" }
];

function replaceEscapedCharacters(string: string) {
    let content = string;

    escapedChararacters.forEach(
        char => (content = content.replaceAll(char.escaped, char.regular))
    );

    return content;
}

export function getDescriptionHtml(vacancy: VacancyProps) {
    if (vacancy.isZZP) {
        return vacancy.inhoud ? `<p>${vacancy.inhoud}</p>` : null;
    }

    const parsedDescription: VacancyDescription =
        vacancy.description && JSON.parse(vacancy.description);

    return Object.keys(parsedDescription)
        .map(key => {
            const heading =
                vacancy.descriptionHeadings?.[key as keyof VacancyDescription];

            const content = parsedDescription[key as keyof VacancyDescription];

            return `${heading ? `<strong>${heading}</strong>` : ""}${
                content ? replaceEscapedCharacters(content) : ""
            }`;
        })
        .join("<br>");
}
